export const getEndpointURL = () => {
    const { REACT_APP_PROTOCOL, REACT_APP_DOMAIN_NAME, REACT_APP_PORT } = process.env;

    if (REACT_APP_PROTOCOL && REACT_APP_DOMAIN_NAME) {
        const port = REACT_APP_PORT ? `:${REACT_APP_PORT}` : "";
        return `${REACT_APP_PROTOCOL}${REACT_APP_DOMAIN_NAME}${port}`;
    }

    if (typeof window !== "undefined" && window.location?.origin) {
        return window.location.origin;
    }

    return "";
}
